// extracted by mini-css-extract-plugin
module.exports = {"container":"syncingInput_container__3TQuv"};